import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AuthenticatedUserRepositoryService {
    private changedUserSource = new Subject<any>();
    private loggedUserSource = new Subject<any>();
    private resetedUserSource = new Subject<null>();
    protected user = null;
    protected loggedWithPassword = true;
    public changedUser$ = this.changedUserSource.asObservable();
    public loggedUser$ = this.loggedUserSource.asObservable();
    public resetedUser$ = this.resetedUserSource.asObservable();

    /**
     * 'user' propery setter. This call userWasChanged event from all listeners.
     **/
    public setUser(user) {
        this.user = user;
        this.changedUserSource.next(user);
        if (user === null) {
            this.resetedUserSource.next(null);
        } else {
            this.loggedUserSource.next(user);
        }
    }
    /**
     * 'user' property getter.
     **/
    public getUser() {
        return this.user;
    }

    /**
     * 'loggedWithPassword' property getter.
     **/
    public isLoggedWithPassword(): boolean {
        return this.loggedWithPassword;
    }
    /**
     * 'loggedWithPassword' property setter.
     **/
    public setLoggedWithPassword(value: boolean): boolean {
        return this.loggedWithPassword = value;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/payment/services/authenticated-user-repository.service.ts